import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect ,useCallback } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Sentence from "../../QuestionPage/DragAndDrop";
// Fetching Data from the API]

// End

// Page Html
export default function ReArrangeSentenceMockPage({ question , onInputChange , maxQuestion ,questionNumber }) {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const [originalSentences, setOriginalSentences] = useState([]);
  const [draggableSentences, setDraggableSentences] = useState([]);
  const [Title, setTitle] = useState("");
  const [originalAnswer, setOriginalAnswer] = useState("");


  useEffect(() => {
    if (question && question.q_title) {
      setTitle(question.q_title);
      const fetchedSentences = question.option.map(option => ({ ...option, text: option.options }));
      
      const shuffledOriginal = shuffleArray([...fetchedSentences]);
      const shuffledDraggable = shuffleArray([...fetchedSentences]);

      setOriginalSentences(shuffledOriginal);
      setDraggableSentences(shuffledDraggable);
    }
  }, [question]);

  console.log("Original Sentences:", originalSentences);
  console.log("Draggable Sentences:", draggableSentences);


  const updateAnswer = useCallback(() => {
    const userOrder = draggableSentences.map((sentence) => sentence.index + 1);
    console.log("User's order of sentences:", userOrder.join(","));
    
    const answer = userOrder.join(",");
    onInputChange(answer);
  }, [draggableSentences, onInputChange]);

  useEffect(() => {
    updateAnswer();
  }, [draggableSentences]);
  

  const moveSentence = (dragIndex, hoverIndex, boxType) => {
    const sourceArray = boxType === "original" ? originalSentences : draggableSentences;
    const newSentences = [...sourceArray];
    const draggedSentence = newSentences[dragIndex];

    newSentences.splice(dragIndex, 1);
    newSentences.splice(hoverIndex, 0, draggedSentence);

    if (boxType === "original") {
      setOriginalSentences(newSentences);
    } else {
      setDraggableSentences(newSentences);
    }
  };

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };







  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h3 className="text-lg  pt-3 font-bold text-gray-900 sm:text-2xl ml-1 text-center md:text-start">
          Mock Test
        </h3>
        <h2 className=" absolute  text-1xl font-bold right-10 top-10">
          {" "}
        </h2>
        <h2 className=" absolute  text-sm font-semibold text-gray-700 right-10 top-13">
          {" "}
        Question {questionNumber} of {maxQuestion}
        </h2>
        <p className="p-2">
        You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.
        </p>

        <DndProvider backend={HTML5Backend}>
          <div className="flex">
            <div className="w-1/2 pr-5 p-4 ">
              <h2 className="text-lg font-semibold mb-3">Original Sentences</h2>
              <div className="border border-gray-300 rounded-md p-4 bg-blue-100">
                {originalSentences.map((sentence, index) => (
                  <div key={sentence.id} className="p-2 border border-gray-300 rounded-md bg-blue-50">
                    {sentence.options}
                  </div>
                ))}
              </div>
            </div>
            <div className="w-1/2 pl-5 p-4 ">
              <h2 className="text-lg font-semibold mb-3">Draggable Sentences</h2>
              <div className="border border-gray-300 rounded-md p-4 bg-green-100">
                {draggableSentences.map((sentence, index) => (
                  <Sentence
                    key={sentence.id}
                    sentence={sentence}
                    index={index}
                    moveSentence={(dragIndex, hoverIndex) => moveSentence(dragIndex, hoverIndex, "draggable")}
                  />
                ))}
              </div>
            </div>
          </div>
        </DndProvider>

      </div>
    </div>
  );
}
